/* eslint react/no-multi-comp: 0 */
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import ContentCaption from './content_caption';
import Lazy from '../common/lazy';

export default class GetEmbedRevealSection extends PureComponent {
  render() {
    return (
      <div className="section-reveal-container">
        {
          this.props.content.images.map((image, index) =>
            <RevealImage
              key={index}
              {...image}
            />
          )
        }
        {
          this.props.content.credit
          && <ContentCaption credit={this.props.content.credit} />
        }
      </div>
    );
  }
}

GetEmbedRevealSection.propTypes = {
  content: PropTypes.shape({
    images: PropTypes.arrayOf(PropTypes.object).isRequired,
    credit: PropTypes.string
  })
};

export class RevealImage extends PureComponent {
  render = () =>
    <div className="full-reveal">
      <Lazy
        className={classNames(
          'reveal-image',
          'landscape'
        )}
      >
        <div className="reveal-fixed-wrap">
          <div className="reveal-fixed">
            <img
              className="landscape-img"
              src={this.props.landscape.src}
              alt={this.props.landscape.alt_title}
            />
          </div>
        </div>
      </Lazy>
      <Lazy
        className={classNames(
          'reveal-image',
          'portrait'
        )}
      >
        <div className="reveal-fixed-wrap">
          <div className="reveal-fixed">
            <img
              className="portrait-img"
              src={this.props.portrait.src}
              alt={this.props.portrait.alt_title}
            />
          </div>
        </div>
      </Lazy>
    </div>;
}

RevealImage.propTypes = {
  portrait: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt_title: PropTypes.string,
    dimensions: PropTypes.shape({
      original_width_px: PropTypes.number.isRequired,
      original_height_px: PropTypes.number.isRequired
    }).isRequired
  }),
  landscape: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt_title: PropTypes.string,
    dimensions: PropTypes.shape({
      original_width_px: PropTypes.number.isRequired,
      original_height_px: PropTypes.number.isRequired
    }).isRequired
  })
};

RevealImage.contextTypes = {
  location: PropTypes.object
};
